export default __webpack_public_path__ + "static/media/inflation.762aa3a8.png";